import { SET_IS_SEARCH } from "../../types/Reservations/DailyManifestReport.type";

export const setIsSearch = (payload) => ({
  type: SET_IS_SEARCH,
  payload,
});
